import { useEffect, useState } from "react";
import { usePWAInstall } from "@/hooks/usePWAInstall";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";
import { triggerHaptic } from "@/utils/haptics";
import { Card } from "@/components/ui/card";

export const PWAInstallPrompt = () => {
  const { isInstallable, promptInstall, dismissInstall } = usePWAInstall();
  const [hasVisited, setHasVisited] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const visits = parseInt(localStorage.getItem('visit-count') || '0');
    localStorage.setItem('visit-count', (visits + 1).toString());
    setHasVisited(visits >= 1);

    const dismissed = localStorage.getItem('pwa-install-dismissed');
    setIsDismissed(!!dismissed);
  }, []);

  const handleInstall = async () => {
    triggerHaptic('medium');
    const success = await promptInstall();
    if (success) {
      triggerHaptic('success');
    }
  };

  const handleDismiss = () => {
    triggerHaptic('light');
    dismissInstall();
    setIsDismissed(true);
  };

  if (!isInstallable || !hasVisited || isDismissed) return null;

  return (
    <Card className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-30 p-4 shadow-lg animate-slide-up">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
          <Download className="h-6 w-6 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-sm mb-1">Installera KlarFinans</h3>
          <p className="text-xs text-muted-foreground mb-3">
            Snabbare åtkomst & offline-läge
          </p>
          <div className="flex gap-2">
            <Button
              size="sm"
              onClick={handleInstall}
              className="flex-1"
            >
              Installera
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={handleDismiss}
            >
              Inte nu
            </Button>
          </div>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={handleDismiss}
          className="flex-shrink-0 h-6 w-6 -mt-1"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </Card>
  );
};
